// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#d82231","stepperActive":"#404041","stepperTextColor":"#fff"};